import Vue from "vue";
import notification from "./notification";
import date from "./date";
import image from "./image";
import permissions from "./permissions";
import status from "./status";
import support from "./support";
import validation from "./validation";

Vue.mixin(date);
Vue.mixin(image);
Vue.mixin(notification);
Vue.mixin(permissions);
Vue.mixin(status);
Vue.mixin(support);
Vue.mixin(validation);
